module.exports = __webpack_public_path__ + "img/08.7ca52e3a.png";